module.exports = __webpack_public_path__ + "static/img/celoscope-1.78ea207.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/celoscopepic/celoscope-1.jpg
// module id = XkY2
// module chunks = 52